import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { profileInfoDefaultValues } from '../../constants';
import {
  setProfileFormIsEditable,
  updateAgencyInfo,
  setProfileFormIsNotEditable,
} from '../../actions';
import {
  selectCurrentSelectedAgency,
  selectProfileFormIsEditable,
  selectProfileFormIsLoading,
} from '../../selectors';
import useAlert from '../../useAlert';

import validate from './validator';

const useProfileInfo = () => {
  const [values, setValues] = useState(profileInfoDefaultValues);
  const setIsEditable = useAction(setProfileFormIsEditable);
  const { agencyName, agencyID, partnerAgencyID, partnerID, active } = useSelector(
    selectCurrentSelectedAgency,
  );
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const { showAlert, hideAlert } = useAlert();
  const dispatchUpdateAgencyInfo = useAction(updateAgencyInfo);
  const dispatchNotEditable = useAction(setProfileFormIsNotEditable);
  const isEditable = useSelector(selectProfileFormIsEditable);
  const isLoading = useSelector(selectProfileFormIsLoading);

  useEffect(() => {
    setValues({
      ...values,
      agencyName,
      agencyID,
      partnerAgencyID,
      partnerID,
      active,
    });
  }, [agencyName, agencyID, partnerAgencyID, partnerID, active]);

  useEffect(() => {
    if (agencyName === values.agencyName && active === values.active) {
      setIsSaveDisabled(true);

      return;
    }

    setIsSaveDisabled(false);
  }, [values]);

  const handleCancel = () => {
    dispatchNotEditable();
  };

  const handleAgencyNameChange = value => setValues({ ...values, agencyName: value });

  const handleToggleChange = checked => setValues({ ...values, active: checked });

  const handleSave = async () => {
    const message = validate(values);

    if (message) {
      showAlert({ message, color: 'error', icon: 'exclamation' });

      return;
    }

    hideAlert();
    dispatchUpdateAgencyInfo(values);
  };

  return {
    values,
    isEditable,
    setIsEditable,
    isLoading,
    handleCancel,
    handleAgencyNameChange,
    handleToggleChange,
    handleSave,
    isSaveDisabled,
  };
};

export default useProfileInfo;
